import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import warningIcon from './images/warning.svg';
import styles from './CompletedSuccessfulComponent.scss';

const CallFilterSocMsg = () => {
  return (
    <div className='call-filter-soc-message'>
      <div className='call-filter-message-title'>
        <div>{<Image src={warningIcon} />}</div>
        <div>
          במסגרת תכנית {window.Config.brand_Name_HE}-צה"ל לאנשי קבע ואע"צים, הנכם זכאים לשירות ניהול שיחות בחו"ל- ללא עלות! השירות מאפשר שליטה בקבלת שיחות נכנסות
          באמצעות קוד אישי בן 4 ספרות שישמש את מי שמתקשר אליכם בזמן שאתם בחו"ל. להפעלת השירות באופן אוטומטי יש לחייג ל-*621 לפני היציאה
          מהארץ. שימו לב- השירות יופעל בחו"ל בלבד ואינו משפיע על קבלת שיחות בארץ.
        </div>
      </div>
      {/* <div className='call-filter-message-text'>להפעלת השירות יש לחייג 610*</div> */}
    </div>
  );
};

export default CallFilterSocMsg;
